<template>
  <div >

    <!--<div style="position: relative; z-index: -1" width="100%">-->
      <!--<v-img src="../assets/images/content/math.png"  ></v-img>-->
    <!--</div>-->

    <Section
        background="black"

    >
<!--       :style="{'background-image': `url(${require('../assets/images/content/background_math2.png')})`}"-->

      <div style="width:100%">
        <nav-bar></nav-bar>
      </div>


      <div class="main-heading" :style="sty_fold_height">
        <div class="heading-line">
          <div class="center  pt-0" :style="sty_fold_txt_1">
             Advizer Optimizes Dealer Performance
          </div>
           <div class="center " :style="sty_fold_txt_2">
              Sales
              <svg width="10" :height="sty_dot_height" >
                 <circle r="5" cx="5" cy="15" fill="var(--color-primary)"></circle>
              </svg>

              Marketing

              <svg width="10" :height="sty_dot_height">
                 <circle r="5" cx="5" cy="15" fill="var(--color-primary)"></circle>
              </svg>

              F&I</div>
        </div>
      </div>

    </Section>











    <!-------------------------------product images----------------------------------------------------------------->
    <Section
            background="black"
            transparent
            style="padding-top: 50px"
    >

      <div  class="bg-transparent-light pt-0"   style="width:100%;" >

<!--         <div class="main-heading">-->
<!--            <div class="heading-line">-->
<!--               <div class="center  pt-0" style="font-size: 39pt; font-weight: 400">-->
<!--                  Advizer Optimizes Dealer Performance-->
<!--               </div>-->
<!--               &lt;!&ndash;          <div class="center display-2">Sales | Marketing | F&I</div>&ndash;&gt;-->
<!--               <div class="center " style="font-size: 35pt; font-weight: 300">-->
<!--                  Sales-->
<!--                  <svg width="10" height="30">-->
<!--                     <circle r="5" cx="5" cy="15" fill="var(&#45;&#45;color-primary)"></circle>-->
<!--                  </svg>-->

<!--                  Marketing-->

<!--                  <svg width="10" height="30">-->
<!--                     <circle r="5" cx="5" cy="15" fill="var(&#45;&#45;color-primary)"></circle>-->
<!--                  </svg>-->

<!--                  F&I</div>-->


<!--            </div>-->
<!--         </div>-->








<!--        <div class="section-heading pt-10 pb-0" >Our Customers</div>-->
<!--         autoplay-->
        <vueper-slides
            speed="70000" :slide-ratio="slide_ratio" class="no-shadow" :arrows="show_arrows"
            fixed-height="800px"
        >
          <vueper-slide
                  v-for="(slide, i) in slides"
                  :key="i"
                  :title="slide.title"
                  :content="slide.content"

          >
            <template v-slot:content>
              <div class="slide-container">
                <div class="slide-spacer"></div>

                <div class="slide-content pt-5 pb-5">
<!--                  <div>{{ slide.title }}</div>-->

                   <img :src="slide.img" width="100%">

                </div>
                <div class="slide-spacer"></div>

              </div>

            </template>
          </vueper-slide>
        </vueper-slides>

      </div>


    </Section>




     <!---------features------------------------------------------>
     <Section
         background="white"
     >


        <v-container class="pl-5 pr-5">
           <div style="color: var(--color-primary); font-size: 25pt; font-weight: 500; margin-top: 40px; margin-bottom: 30px;text-align: center">
              Advizer Features
           </div>

           <v-row  class="pb-10">
              <v-col cols="12" md="6" class="advizer-feature-container">
                 <img src="../assets/images/icons/ascendant-bars-graphic.svg" width="30px">
                 <span class="advizer-feature-header">Real-Time Performance Analysis</span>
                 <div class="advizer-feature-text">
                    Advizer constantly analyzes your dealership and forecasts your month-end performance
                    daily using the latest data so that you'll never have month-end surprises.
                 </div>
              </v-col>

              <v-col cols="12" md="6" class="advizer-feature-container">
                 <img src="../assets/images/icons/messages.svg" width="30px">
                 <span class="advizer-feature-header">Automatic Alerts</span>
                 <div class="advizer-feature-text">
                    Advizer monitors key metrics if an anomaly or performance issue is detected, Advizer will alert
                    you with either an SMS text message or an email so you can fix it immediately.
                 </div>
              </v-col>

              <v-col cols="12" md="6" class="advizer-feature-container">
                 <img src="../assets/images/icons/analytics2.svg" width="30px">
                 <span class="advizer-feature-header">Mobile or Desktop</span>
                 <div class="advizer-feature-text">
                    Whether at your desk or on your phone, Advizer is designed to work perfectly.  With a mobile-first design,
                    you can take the power of Advizer with you anywhere.
                 </div>
              </v-col>

              <v-col cols="12" md="6" class="advizer-feature-container">
                 <img src="../assets/images/icons/stethoscope.svg" width="30px">
                 <span class="advizer-feature-header">Diagnostic Engine</span>
                 <div class="advizer-feature-text">
                    When an issue is detected, Advizer's real-time diagnostic engine can isolate it's source in seconds.
                 </div>
              </v-col>

<!--              <v-col cols="6" class="advizer-feature-container">-->
<!--                 <img src="../assets/images/icons/lamp.svg" width="30px">-->
<!--                 <span class="advizer-feature-header">Automated Insights</span>-->
<!--                 <div class="advizer-feature-text">-->
<!--                    System continuously analyzes data looking for insights and pushes them to the inbox when it finds them-->
<!--                 </div>-->
<!--              </v-col>-->
           </v-row>
        </v-container>

     </Section>




     <!---------technology------------------------------------------>
     <Section
         background="black"
     >


        <v-container class="pl-5 pr-5">
           <div style="color: var(--color-primary); font-size: 25pt; font-weight: 500; margin-top: 40px; margin-bottom: 30px;text-align: center">
              Technology
           </div>

           <v-row class="pb-10">
              <v-col cols="12" md="6" class="advizer-feature-container">
                 <img src="../assets/images/icons/database.svg" width="30px">
                 <span class="advizer-feature-header">Central Data Warehouse</span>
                 <div class="advizer-feature-text">
                    A dealership's data is typically spread across multiple systems which don't talk to each other.
                    Advizer connects to all of your data sources and creates a central data store.
                 </div>
              </v-col>

              <v-col cols="12" md="6" class="advizer-feature-container">
                 <img src="../assets/images/icons/network.svg" width="30px">
                 <span class="advizer-feature-header">Semantic Relational Mapping</span>
                 <div class="advizer-feature-text">
                    Advizer uses a proprietary Semantic Relational Map (SRM) to encode how your
                    dealership's data relates to each other.  For every one of our clients, we build a unique SRM that powers
                    Advizer's automated analytics capabilities.
                 </div>
              </v-col>

              <v-col cols="12" md="6" class="advizer-feature-container">
                 <img src="../assets/images/icons/algorithm.svg" width="30px">
                 <span class="advizer-feature-header">Recursive Diagnostic Engine</span>
                 <div class="advizer-feature-text">
                    Advizer's Diagnostic Engine monitors key metrics and looks for statistically meaningful deviations from
                    baseline levels.  Once an issue is detected, it then uses the Semantic Relational Map to explore related
                    metrics to uncover what's really driving the issue.
                 </div>
              </v-col>

              <v-col cols="12" md="6" class="advizer-feature-container">
                 <img src="../assets/images/icons/padlock.svg" width="30px">
                 <span class="advizer-feature-header">Enterprise Grade Security</span>
                 <div class="advizer-feature-text">
                    Advizer is secured with enterprise grade security.  OAuth (used by Google, Facebook, Microsoft, etc.)
                    and the industry standard SSL are used for user authentication and data encryption.  In addition
                    any sensitive information is encrypted at rest within our database.
                 </div>
              </v-col>


           </v-row>
        </v-container>

     </Section>












    <!--<div class="process-section">-->

      <!--some extra space for the moment-->

    <!--</div>-->



  </div>

</template>






<style scoped lang="scss">


  .image-bg{
    background-size: cover;
    background-position: center;
  }


  .main-heading{
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;

    }

  .heading-line{

    text-align: center;

  }


  .process-section{
    height: 700px;
    text-align: justify;

  }



  .bg-transparent-light{
    background: rgba(255, 255, 255, 0.05);
    width:100%;
  }


  .section-heading{
    font-size: 3em;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    text-align: center;

  }


  .section-sub-heading {
    font-size: 2em;
    font-weight: normal;
     width: 100%;
     text-align: center;
  }



  .container-services{
    max-width: 1200px;
    text-align: center;


    /*.service-heading{*/
      /*font-size: 2em;*/
      /*font-weight: normal;*/
    /*}*/

    .service-text{
      font-size: 1.0em;
      /*font-weight: lighter;*/
      line-height: 110%;
      text-align: justify;
      padding-top: 10px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .colored-icon-text{
    font-size: 1.4em;
    /*font-size: 1.0em;*/
    /*text-align: left;*/
    text-align: justify;
    max-width: 800px;
  }







//***********settings for slider***************************


  .slide-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 800px;
  }

  .slide-content{
    margin: auto;
    padding-left: 20px;
    padding-right: 20px;
    max-width: 1000px;

  }
  .slide-spacer{
    flex: 'flex-grow';
  }





//********settings for ease as 123 section***************

  .numbered-item{
     display: block;
     text-align: left;
  }


  .numbered-line{
     display: flex;
     justify-content: flex-start;
     align-items: center;

  }

  .numbered-line-text{
     font-size: 17pt;
     font-weight: 500;
     margin-top: -7px;
     margin-left: 7px
  }
  .numbered-line-fine-print{
     //padding-left: 10px;
     margin-top: -5px;
     margin-left: 5px;
     font-size: 12pt;
     max-width: 450px;
  }

//*******settings for why advizer ************************

  .why-text{
     padding: 10px;
     font-size: 1.5em;
     font-weight: 200;
     max-width: 800px;
     text-align: justify;

  }


  //******features**************

  .advizer-feature-container{
     padding-top: 20px;
     padding-bottom: 20px;

  }
  .advizer-feature-header{
     font-size: 20pt;
     font-weight: 500;
     padding-left: 10px;
  }

  .advizer-feature-text{
     font-size: 15pt;
  }

</style>


<script>
// @ is an alias to /src
import Section from '@/components/Section.vue'
import Contact from '@/components/ContactForm.vue'
import navBar from '@/components/navBar.vue'

import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'


export default {
  name: 'product',
  components: {navBar, Section, Contact, VueperSlides, VueperSlide},
   data(){return {
      slide_duration: 12,
      slides: [
         {
            title: 'screenshot1',
            img: require('../assets/images/tmp/product1.png'),
            comment: 'comment'

         },

         {
            title: 'screenshot1',
            img: require('../assets/images/tmp/product2.png'),
            comment: 'comment'
         },

         {
            title: 'screenshot1',
            img: require('../assets/images/tmp/product3.png'),
            comment: 'comment'

         },

         {
            title: 'screenshot1',
            img: require('../assets/images/tmp/product4.png'),
            comment: 'comment'

         },


         // {
         //    title: 'DealerKnows Training',
         //    content: 'The guys at Espy Data Science built a custom app for us under a very tight deadline and did a great job.  ' +
         //       'I look forward to working with them on future projects.',
         //    author: 'Bill, Founder'
         // },

      ]
   }},

   methods:{
      track (eventLabel, category='SiteNavigation') {
         this.$gtag.event('ButtonClick', {
            'event_category': category,
            'event_label': eventLabel,
         })
      }
   },

   computed:{

      //********responsive style properties for main fold **************************************
      sty_fold_height(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'height: 450px';
         }
         else {
            return 'height: 350px';
         }
      },

      sty_fold_txt_1(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'font-size: 39pt; font-weight: 400';
         }
         else {
            return 'font-size: 25pt; font-weight: 400';
         }
      },

      sty_fold_txt_2(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'font-size: 35pt; font-weight: 300';
         }
         else {
            return 'font-size: 21pt; font-weight: 300; margin-top: 15px;';
         }
      },

      sty_dot_height(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return '30';
         }
         else {
            return '25';
         }
      },

     show_arrows(){
        if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)) {
           return false;
        }
        else{
           return true;
        }
     },

     slide_ratio(){

        if (['xs'].includes(this.$vuetify.breakpoint.name)){
           return 0.7;
        }

        else if (['sm'].includes(this.$vuetify.breakpoint.name)){
           return 0.5;
        }
        else {
           return 0.3;
        }
     }
   },

   created(){
   }


}
</script>
